import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { useSelector } from "react-redux";
import { history } from "redux/configureStore";
import { titleFromPath } from "app/header/parts/HeaderTitle";
import { _t } from "app/i18n/i18n";

export const ResearchBreadcrumb = ({ margin }) => {
  const path = useSelector((state) => state.filter.path);
  return <ResearchBreadcrumbForPath path={path} margin={margin} />;
};

export const ResearchBreadcrumbForPath = ({ path, margin = "mt-0" }) => {
  const trail = createTrail(path);
  return (
    <section className="d-none d-md-block">
      <Breadcrumb
        variant="dark"
        className="text-uppercase small text-gray font-weight-lighter pb-0 mb-0 cursor-pointer"
      >
        {trail.map((item, key) => (
          <Breadcrumb.Item key={key} href="#" onClick={() => history.push(item)} active={key !== trail.length}>
            {_t(titleFromPath(item))}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
      <h4 className={`d-block ${margin} pt-0 text-dark font-weight-lighter`}>{_t(titleFromPath(path))}</h4>
    </section>
  );
};

const createTrail = (path = "") => {
  let ret = [];
  let pathArr = path.split("/");
  for (let i = 0; i < pathArr.length; i++) {
    ret.push(pathArr.slice(0, i).join("/"));
  }
  return ret.filter((i) => i.length);
};
